import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { apiGeEmInfo, apiGetConfigList, apiGetEmCount, apiGettKfInfo, apiGetUserInfo } from '../api';
import main, { AppLocalKey } from '../main';
import { parseLocationParams, showConfirm, showToast } from '../utils/utils';
import FloatComplaint from './homePage/floatComplaint';
import FloatCustomer from './homePage/floatCustomer';

let isWeixin = true;
export default function MainPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [over, setOver] = useState(false);
  const [showCustomer, setShowCustomer] = useState(false);
  const [showTabBar, setshowTabBar] = useState(false);

  // 底部 Tab 菜单
  const tabList = [
    { name: '首页', path: '/home', icon: 'icon_nav_home', activeIcon: 'icon_nav_home_active' },
    { name: '投诉', path: '/complaint-index', icon: 'icon_nav_order', activeIcon: 'icon_nav_order_active' },
    { name: '客服', path: '/customer', icon: 'icon_nav_user', activeIcon: 'icon_nav_user_active' },
  ];

  useEffect(() => {
    setshowTabBar(['/home', '/customer', '/complaint-index'].includes(location.pathname))
    if(location.pathname === '/home'){
      loadCurrentEM();
    }
   
  }, [location.pathname]);
  // 当前设备
  const [currentEm, setcurrentEm] = useState<CurrentEm>();
  useEffect(() => {
    let ua = window.navigator.userAgent.toLowerCase();
    let params = parseLocationParams(window.location.search);
    if (!!params.cid) {
      main.nextBindEm = params.cid;
    }
    isWeixin = ua.includes('micromessenger');
    let openId = localStorage.getItem(main.appId);
    let uri = window.location.href;
    let redirect_uri = encodeURIComponent(uri);
    if (isWeixin && !window.location.search.includes('code') && !openId) {
      document.location.replace(
        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${main.appId}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
      );
    } else if (isWeixin && window.location.search.includes('code') && !openId) {
      let t = window.location.search.split('?')[1].split('&');
      let code = '';
      for (let s of t) {
        if (s.includes('code')) {
          code = s.split('=')[1];
          break;
        }
      }
      if (code) {
        main.code = code;
      }
    }
    if (openId) {
      main.openId = openId;
    }
    checkLoginKey();
    loadConfig();
    
  }, []); // eslint-disable-line
  useEffect(() => {
    // 客服悬浮按钮 部分页面不显示
    const hidePage = ['/customer', '/complaint-index', '/complaint', '/complaint-list', '/complaint-detail'];
    let hide = hidePage.includes(location.pathname);
    setShowCustomer(!hide);
  }, [location]); // eslint-disable-line
  function checkLoginKey() {
    if (main.isIos14) {
      main.enterUrl = window.location.href;
    }
    let key = localStorage.getItem(AppLocalKey.loginToken);
    main.loginKey = key;
    const url = new URL(window.location.href); // 获取当前页面 URL
    const type = url.searchParams.get('loginType') || '';
    const number = url.searchParams.get('emNumber') || '';
    const linkPhone = url.searchParams.get('phone') || '';
    const emId = url.searchParams.get('emId') || '';

    main.emNumber = number;
    main.emId = emId;
    if (type && number && linkPhone && emId) {
      setOver(true);
      localStorage.setItem('ispreview', 'true');
      return routeToPage('/login', { type, number, linkPhone, emId });
    }
    if (!key) {
      localStorage.removeItem('ispreview');
      setOver(true);
      routeToPage('/login');
    } else {
      main.ispreview = localStorage.getItem('ispreview') === 'true';
      setOver(false);
      loadUserInfo(key);
    }
    // let isLogin = localStorage.getItem('isLogin');
    // if (isLogin) {
    //   if (location.pathname.includes('/login') || location.pathname === '/') {
    //     navigate('/home', { replace: true });
    //   }
    // } else if (!whiteList.includes(location.pathname)) {
    //   navigate('/login', { replace: true });
    // }
  }

  async function loadConfig() {
    if (main.configList?.length) return;
    try {
      let configRes = await apiGetConfigList();
      let configData = configRes.data;
      if (configData.code === 200) {
        main.configList = configData.data;
      }
    } catch (e: any) {
      console.log(e);
    }
  }

  async function loadUserInfo(token: string) {
    try {
      let res = await apiGetUserInfo(token);
      let data = res.data;
      setOver(true);
      if (data.code === 200) {
        main.user = data.data.user;
      }
    } catch (e: any) {
      console.error(e);
    }
    if (main.user?.userId) {
      if (!!main.nextBindEm) {
        routeToPage('/add-em');
      } else {
        let res = await apiGetEmCount();
        let data = res.data;
        if (data.data <= 0) {
          routeToPage('/em-list', { backToOut: true });
        } else {
          let url = location.pathname;
          url = '/home';
          routeToPage(url);
        }
      }
    } else {
      routeToPage('/login');
    }
  }

  async function loadCurrentEM() {
    try {
      let res = await apiGeEmInfo();
      let data = res.data;
      if (data.data) {
        main.currentEm = data.data;
        setcurrentEm(data.data);
      } else {
        // 没有卡
      }
    } catch (e: any) {
      // TODO: 网络错误
    }
  }
  function getTabList() {
    // 在tabList 中添加新的 tab index为倒数第二个
    let newTabList = [...tabList];
    newTabList.splice(
      newTabList.length - 1, 0,
      { name: '电话', path: 'dialog', icon: 'icon_nav_phone', activeIcon: 'icon_nav_phone_active' }
    );
    return newTabList;
  }
  function routeToPage(page: string, state?: any) {
    if (!isWeixin && !main.isDev) {
      showToast('请在微信环境内浏览，避免使用故障');
    }
    navigate(page, { replace: true, state });
  }

  if (!over) {
    return (
      <div className="vw-100 vh-100 d-flex-c ai-center jc-center pt-40 pb-20">
        <img src="/pic/logo.png" className="icon-80 mb-20" alt="" />
        <div className="text-color-p flex-1">网司令</div>
        <div className="text-color-p">WANGSILING</div>
      </div>
    );
  }
  async function showCallPhoneDialog(phone?: string) {
    if (!phone) return;
    let res = await showConfirm({
      title: '呼叫确认',
      content: `是否呼叫客服热线${phone}?`,
      confirmBtnText: '确认',
      cancelBtnText: '取消',
    });
    if (!res) return;
    const num = phone.replace(/[^\d+]/g, '');
    window.location.href = `tel:${num}`;
  }
  return (
    <div className={`${showTabBar && currentEm?.sysDept?.showBottomMenu === 'Y' ? 'pb-60' : ''}`}>
      <Outlet />
      {showCustomer && <FloatCustomer onClick={() => navigate('/customer')} />}
      {showCustomer && <FloatComplaint onComplaint={() => navigate('/complaint-index')} />}
      {showTabBar && currentEm?.sysDept?.showBottomMenu === 'Y' && (
        <div className="bw-100 bg-white border-top pos-f l-0 b-0 pt-10 pb-10 d-flex-r ai-center jc-around z-99">
          {(currentEm?.sysDept?.bottomServerPhone ? getTabList() : tabList || []).map((item) => (
            <div
              key={item.path}
              onClick={async () => {
                if (item.path === 'dialog') {
                  return showCallPhoneDialog(currentEm?.sysDept?.bottomServerPhone)
                }
                if (item.path === '/customer') {

                  let res1 = await apiGettKfInfo(currentEm?.emNumber || '', 'bottom');
                  if (res1?.data?.data?.urlContract) {
                    if (res1?.data?.data?.urlType === 'image') {
                      return window.location.href = `https://dlc.10086iot.net/feeConfig?url=${encodeURIComponent(res1?.data?.data?.urlContract)}&en=${currentEm?.emNumber
                        }}`
                    } else if(res1?.data?.data?.urlType === 'link') {
                      return window.location.href = res1?.data?.data?.urlContract;
                    }

                  } else {
                    return navigate(item.path)
                  }
                }
                navigate(item.path)
              }}
              className={`${location.pathname === item.path ? 'text-color-blue' : 'text-color-6'
                } d-flex-c ai-center font-size-12`}
            >
              <img
                className="w-25 h-25 mb-3"
                src={`/pic/${location.pathname === item.path ? item.activeIcon : item.icon}.png`}
                alt=""
              />
              <div>{item.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
